import Emitter from "./Emitter";

export default class CloseHelp extends Emitter {
    constructor(gb) {
        super(gb);
    }

    ENDOR_handler(){
        this.emitGame({messageId: "toggleHelp", action: "hide" })
    }

    HABANERO2_handler(){
        this.emitGame({type: "toggleHelp"});
    }

    _default() {
        this.emitGame({ wpgaction: "closeHelp" });
    }
}
